import appDay from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
// import isToday from "dayjs/plugin/isToday";

// appDay.extend(isToday);
appDay.extend(utc)
appDay.extend(timezone)

export { appDay }
